// Import enumerations.
import {
	EligibilityStatusCode
} from '@app/enumerations';

export default class EligibilityStatus {
	public statusCode: EligibilityStatusCode | null = null;
	public problems: string[] = [];

	public constructor() {

	}
};